<template>
  <div>
    <div class="section">
      <div class="container">
        <p v-if="loadingRecordings">
          Loading...
        </p>
        <p
          v-if="recordings.length === 0 && !loadingRecordings"
          class="has-text-grey has-text-centered"
        >
          This student has not shared any recordings with you yet.
        </p>
        <b-table
          v-if="recordings.length > 0"
          :data="recordings"
          class="has-text-left"
          default-sort-direction="desc"
          default-sort="date"
          :per-page="perPage"
          :paginated="paginated"
          detailed
          detail-key="guid"
        >
          <b-table-column field="date" label="Recorded" sortable v-slot="props">
            <p class="has-text-grey">
              {{ new Date(props.row.date) | formatDate }}
            </p>
          </b-table-column>
          <b-table-column field="bookName" label="Book" sortable v-slot="props">
            {{ getBookById(props.row.bookId).name }}
          </b-table-column>
          <b-table-column
            field="sectionNumber"
            label="Paragraph"
            sortable
            v-slot="props"
          >
            <router-link
              :to="
                getSectionPath(
                  props.row.bookId,
                  props.row.sectionNumber,
                  'Reading'
                )
              "
            >
              Paragraph {{ props.row.sectionNumber }}
            </router-link>
          </b-table-column>
          <b-table-column
            field="praised"
            label="Praise"
            sortable
            centered
            v-slot="props"
          >
            <b-icon
              v-if="props.row.praised"
              pack="fas"
              icon="star"
              type="is-warning"
            />
          </b-table-column>
          <b-table-column
            field="feedback"
            label="Feedback"
            sortable
            centered
            v-slot="props"
          >
            <b-icon
              v-if="props.row.feedback"
              pack="fas"
              icon="comment-alt"
              type="is-success"
            />
          </b-table-column>
          <template #detail="props">
            <div class="columns is-centered">
              <div class="column is-6">
                <div class="box is-6">
                  <WaveformPlayer
                    :src="props.row.recordingUrl"
                    :from="0"
                    text="Recorded"
                  />
                  <br />
                  <WaveformPlayer
                    :src="props.row.originalAudioUrl"
                    :from="props.row.startTime"
                    :to="props.row.endTime"
                    text="Original"
                  />
                  <br />
                  <p class="is-size-7-mobile">{{ props.row.text }}</p>
                  <div
                    v-if="props.row.feedback"
                    class="mt-3 has-background-light section"
                  >
                    <p class="has-text-weight-bold">Feedback:</p>
                    <p class="is-italic">{{ props.row.feedback }}</p>
                  </div>
                </div>
                <Feedback
                  :recordingGuid="props.row.guid"
                  :praised="props.row.praised"
                  :edit="!!props.row.feedback"
                  @praised="praise(props.row)"
                  @feedbackSubmitted="handleFeedback(props.row, ...arguments)"
                />
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import filtersMixin from "../mixins/filtersMixin";
import routeMixin from "../mixins/routeMixin";
import WaveformPlayer from "../components/WaveformPlayer";
import Feedback from "../components/StudentRecordings/Feedback";
import dataService from "../services/dataService";
export default {
  mixins: [filtersMixin, routeMixin],
  components: { WaveformPlayer, Feedback },
  data() {
    return {
      perPage: 50,
      loadingRecordings: false,
      recordings: []
    };
  },
  computed: {
    ...mapGetters(["getBookById"]),
    studentGuid() {
      return this.$route.params.studentGuid;
    },
    paginated() {
      return this.recordings.length > this.perPage;
    }
  },
  methods: {
    ...mapActions(["fetchBooksAction"]),
    async fetchRecordings() {
      this.loadingRecordings = true;
      this.recordings = await dataService.getStudentRecordings(
        this.studentGuid
      );
      this.loadingRecordings = false;
    },
    praise(recording) {
      recording.praised = true;
    },
    handleFeedback(recording, feedback) {
      recording.feedback = feedback;
    }
  },
  async created() {
    // Fetching books here because child components will need to get book names by id
    await this.fetchBooksAction();
    this.fetchRecordings();
  }
};
</script>

<style lang="scss" scoped></style>
